import { FC, ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material/styles';

// Asets
import LaptopImage from 'Assets/laptop.png';

// Components
import MapleContainer from 'Components/ds/MapleContainer';
import MapleButton from 'Components/ds/MapleButton';
import Typography from 'Components/ds/Typography';

// Constants
import { isProtocolPaused } from 'Constants';

const style: { [component: string]: SxProps } = {
  heroWrapper: { position: 'relative', overflow: 'hidden' },
  grid: { minHeight: { xs: 'auto', lg: 'calc(100vh + 32px)' } },
  textWrapper: { height: { xs: 'auto', lg: '100%' } },
  typography: { textAlign: { xs: 'center', lg: 'left' } },
  buttonsWrapper: { pt: 3 },
  imageWrapper: {
    height: '600px',
    transform: {
      lg: 'translateX(450px)',
      xl: 'translateX(140px)',
    },
    position: 'absolute',
    marginTop: 'calc((100vh - 700px)/2)',
    top: 0,
    right: 0,
    display: { xs: 'none', lg: 'block' },
  },
  videoWrapper: {
    position: 'absolute',
    top: '22px',
    left: '102px',
    width: '800px',
    height: '530px',
    overflow: 'hidden',
    video: { width: '100%', transform: 'translateY(-135px)' },
  },
};

const Hero: FC = (): ReactElement => {
  const pathname = isProtocolPaused ? '' : '/#/v2/maple-upgrade';

  return (
    <Box sx={style.heroWrapper}>
      <MapleContainer maxWidth='xl' sx={{ mt: { xs: 10, lg: -13 }, mb: { xs: 10, lg: 0 } }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={12} lg={7} xl={6} sx={style.grid}>
            <Stack direction='column' spacing={3} justifyContent='center' sx={style.textWrapper}>
              <Typography variant='displayLarge' weight='extraBold' color='ds.neutral.900' sx={style.typography}>
                Upgrading to{' '}
                <Typography variant='displayLarge' weight='extraBold' component='span' color='ds.primary.500'>
                  Maple 2.0
                </Typography>
              </Typography>
              <Typography variant='paragraphLarge' color='ds.neutral.700' sx={style.typography}>
                From{' '}
                <Typography variant='paragraphLarge' color='ds.info.500' component='span' weight='bold'>
                  Saturday 10th December 09:00 ET to Wednesday 14th December 09:00 ET
                </Typography>
                , the app will be unavailable whilst we upgrade our smart contracts on Maple Ethereum. This planned
                pause is in place to ensure a smooth transition to new smart contracts and ensure security for all
                protocol participants.
                <br />
                Deposits and withdrawals will not be possible during this time.
              </Typography>
              <Stack
                direction='row'
                spacing={1.5}
                sx={style.buttonsWrapper}
                justifyContent={{ xs: 'center', lg: 'flex-start' }}
              >
                <MapleButton color='primary' href={`${pathname}#features`}>
                  Preview New Features
                </MapleButton>
                <MapleButton color='secondary' href={`${pathname}#contact`}>
                  Contact Maple
                </MapleButton>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </MapleContainer>
      <Box sx={style.imageWrapper}>
        <img src={LaptopImage} height='100%' />
        <Box sx={style.videoWrapper}>
          <video muted={true} playsInline={false} loop={true} autoPlay={true}>
            <source
              src='https://videos.ctfassets.net/qnx1f79oa09i/36Nd5KqWq9RCuoVQWLnn43/10ec3a3187125cf5e4ef2ad47f57e606/Homepage_Header_Desktop_1080p.mp4'
              type='video/mp4'
            />
            Your browser does not support the video tag.
          </video>
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
